import React, { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { useLocation, useNavigate } from 'react-router-dom'
import { Provider } from 'src/stores/GlobalContext'
import { useIsMobileQuery } from 'src/hooks/useMediaQuery'
import MainNavigation from 'src/features/navigation/MainNavigation'
import MobileNavigation from 'src/features/navigation/MobileNavigation'
import layoutStyles from './layouts.module.scss'
import LeftPanelLayout from './LeftPanelLayout'
import RightPanelLayout from './RightPanelLayout'
import useFetchEvent from 'src/queries/events/useFetchEvent'

const restrictedPathsAttended = [
  'speakers',
  'governing-body'
]

const restrictedPathsUnattended = [
  'attendees',
  'leaderboard',
  'messages'
]

const MainLayout = () => {
  const { currentEvent } = useFetchEvent()
  const location = useLocation()
  const isMobileSize = useIsMobileQuery()
  const navigate = useNavigate()
  const isP2P = location.pathname.includes('wizard') || location.pathname.includes('virtual')

  useEffect(() => {
    if (isMobileSize) {
      // This is the fix for https://www.pivotaltracker.com/story/show/186351792
      window.scrollTo(0, 0)
    }
  }, [location])

  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean)

    // Expected shape: ['programs', ':eventId', ...subroute]
    const isProgramsEventRoute = segments[0] === 'programs' && !!segments[1]
    if (!isProgramsEventRoute || isEmpty(currentEvent)) return

    const subroute = segments[2] || ''
    const restrictedPaths = currentEvent.is_attended
      ? restrictedPathsAttended
      : restrictedPathsUnattended

    // This makes both:
    // /programs/7172/attendees and /programs/7172/attendees/230514
    // resolve to subroute === 'attendees'
    if (restrictedPaths.includes(subroute)) {
      navigate(`/programs/${currentEvent.id}`)
    }
  }, [location, currentEvent])

  return (
    <Provider>
      <div
        className={
          isP2P || isMobileSize ? undefined : layoutStyles.mainLayoutContainer
        }
      >
        {isP2P || isMobileSize
          ? undefined
          : (
            <div className={layoutStyles.mainNavContainer}>
              <MainNavigation />
            </div>
          )
        }
        {isMobileSize && <MobileNavigation />}
        {location.pathname.includes('/messages') ||
        location.pathname.includes('/search')
          ? <LeftPanelLayout />
          : <RightPanelLayout isP2P={isP2P} />
        }
      </div>
    </Provider>
  )
}

export default MainLayout
